import { Injectable } from "@angular/core";
import { Organization, OrgNameAndIdentifier } from "../types";

@Injectable({ providedIn: "root" })
export class StorageService {
    organizationNames: OrgNameAndIdentifier[];

    constructor() {}

    _populateNames(organizationResponse: Organization[]): void {
        this.organizationNames = organizationResponse.map(org => {
            return {
                name: org.officialName,
                globalIdentifier: org.globalIdentifier
            };
        });
    }
}
